// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"194":"a0cb1bec","276":"a59ed207"}[chunkId] + ".chunk.css";
};